module.exports = __webpack_public_path__ + "static/media/star-filled.d570b099.svg";